import * as R from 'ramda'
import effects from 'app/effects/effects'
import moment from 'moment'
import {
  pageToSortPairs,
  useTableFetch,
} from 'commons/fullControlReactTableFetch'
import useVoucherDialog from './useVoucherDialog'

const VoucherStatus = {
  ALL: 0,
  ACTIVE: 1,
  FULLY_REDEEMED: 2,
  CANCELED: 3,
  EXPIRED: 4,
}

export const filterOptions = [
  {
    placeHolder: 'dealsPromotions.table.filter.startDate',
    name: 'startDate',
    type: 'DatePicker',
  },
  {
    placeHolder: 'dealsPromotions.table.filter.endDate',
    name: 'endDate',
    type: 'DatePicker',
  },
  {
    name: 'status',
    type: 'Select',
    options: [
      {
        title: 'text.status',
        value: VoucherStatus.ALL,
      },
      {
        title: 'dealsPromotions.status.active',
        value: VoucherStatus.ACTIVE,
      },
      {
        title: 'dealsPromotions.status.fullyRedeemed',
        value: VoucherStatus.FULLY_REDEEMED,
      },
      {
        title: 'dealsPromotions.status.canceled',
        value: VoucherStatus.CANCELED,
      },
      {
        title: 'dealsPromotions.status.expired',
        value: VoucherStatus.EXPIRED,
      },
    ],
  },
]

export default () => {
  const INITIAL_FILTER = {
    startDate: null,
    endDate: null,
    status: 0,
  }

  const fetchData = (page) => {
    let filterStatus =
      page.status !== VoucherStatus.ALL ? { status: page.status } : {}
    const filter = {
      ...filterStatus,
      from: page.startDate && moment(page.startDate).startOf('day').format(),
      to: page.endDate && moment(page.endDate).endOf('day').format(),
      sort: pageToSortPairs(page),
      keyword: page.keyword,
    }

    return effects.apis.getDealsPromotionList({
      page: page.currentPage,
      limit: page.pageSize,
      ...R.reject(R.isNil, filter),
    })
  }

  const [
    { isOpen, initialModel },
    onOpenVoucherFormDialog,
    onCloseVoucherFormDialog,
    handleSetVoucherData,
  ] = useVoucherDialog()

  const tableFetch = useTableFetch(fetchData, INITIAL_FILTER)
  const { search, pageInfo, refetchData, onClearFilter } = tableFetch

  const onCreateSuccess = async () => {
    await refetchData()
    await onCloseVoucherFormDialog()
    await onClearFilter(INITIAL_FILTER)
  }

  return [
    onCreateSuccess,
    isOpen,
    initialModel,
    onOpenVoucherFormDialog,
    onCloseVoucherFormDialog,
    handleSetVoucherData,
    search,
    pageInfo,
    refetchData,
    tableFetch,
    filterOptions,
  ]
}
